<div class="grid-container">
  <div class="div-center">
    <button class="button-main-blue" (click)="openCreateEventDialog(createUserContent)">Создать</button>
  </div>
  <div class="table-container">
    <table class="styled-table">
      <thead>
      <tr>
        <th class="name-column">username</th>
        <th class="name-column">role</th>
        <th class="name-column">token</th>
        <th class="name-column">actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let user of users">
        <td class="name-column">{{ user.username }}</td>
        <td class="name-column" style="text-align: center">{{ user.role }}</td>
        <td class="name-column-password" style="text-align: center">
          <button class="icon-button" (click)="copyToken(user)">
            <i class="material-icons">content_copy</i>
          </button>
        </td>
        <td class="name-column" style="text-align: center">
          <button class="icon-button" (click)="editUser(user,updateUserContent)">
            <i class="material-icons">edit</i>
          </button>
          <button class="icon-button" (click)="generateQRCode(user)">
            <i class="material-icons">qr_code</i>
          </button>
          <button class="icon-button" (click)="copyLink(user)">
            <i class="material-icons">link</i>
          </button>
<!--          <button class="icon-button" (click)="toggleActive(user)">-->
<!--            <i class="material-icons">{{ user.active ? 'toggle_on' : 'toggle_off' }}</i>-->
<!--          </button>-->
          <button class="icon-button" (click)="deleteUser(user)">
            <i class="material-icons">delete</i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>


<ng-template #createUserContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Добавление пользователя</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-group mb-3">
      <label for="username">Username *</label>
      <input type="text" class="form-control" [(ngModel)]="userToCreate.username">
    </div>

    <div class="form-group mb-3">
      <label>Роль *</label>
      <select class="form-control" (change)="onChangeUserCreateRole($event.target.value)">
        <option *ngFor="let role of roles">{{ role }}</option>
      </select>
    </div>

    <div class="form-group mb-3">
      <label for="token">Токен</label>
      <input type="text" [(ngModel)]="userToCreate.token" class="form-control">
    </div>

    <div class="custom-select">
      <label for="multi-select">Выберите элементы:</label>
      <select
        id="multi-select"
        multiple>
        <option *ngFor="let item of events" [value]="item.id" (click)="selectEvent(item)">
          {{ item.name }}
        </option>
      </select>
    </div>

    <div *ngIf="userToCreate.events.length">
      <ul>
        <li *ngFor="let selected of userToCreate.events">
          <div style="display: flex; flex-direction: row;">
            <p>{{ getEventInfo(selected) }}</p>
            <button type="button" class="btn-close" aria-label="Close" (click)="unselect(selected)"></button>
          </div>
        </li>
      </ul>
    </div>

    <div class="button-container">
      <button type="button" class="btn btn-outline-danger" (click)="modal.dismiss()">
        Отмена
      </button>
      <button type="submit" class="btn btn-outline-success" (click)="onSubmitCreateUser(modal)">
        Сохранить
      </button>
    </div>
  </div>
</ng-template>

<ng-template #updateUserContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Изменение пользователя</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-group mb-3">
      <label for="username">Username: {{userToUpdate.username}}</label>
      <input type="text" id="username" class="form-control" [(ngModel)]="userToUpdate.username">
    </div>

    <div class="form-group mb-3">
      <label>Роль *</label>
      <select id="role" class="form-control" (change)="onChangeUserEditRole($event.target.value)">
        <option *ngFor="let role of roles">{{ role }}</option>
      </select>
    </div>

    <div class="form-group mb-3">
      <label for="token">Токен</label>
      <input type="password" id="token" [(ngModel)]="userToUpdate.token" class="form-control">
    </div>

    <div class="custom-select">
      <label for="multi-select">Выберите элементы:</label>
      <select
        id="multi-select"
        multiple>
        <option *ngFor="let item of events" [value]="item.id" (click)="selectEditEvent(item)">
          {{ item.name }}
        </option>
      </select>
    </div>

    <div *ngIf="userToUpdate.events.length">
      <ul>
        <li *ngFor="let selected of userToUpdate.events">
          <div style="display: flex; flex-direction: row;">
            <p>{{ getEventInfo(selected) }}</p>
            <button type="button" class="btn-close" aria-label="Close" (click)="unselectEditEvent(selected)"></button>
          </div>
        </li>
      </ul>
    </div>

    <div class="button-container">
      <button type="button" class="btn btn-outline-danger" (click)="modal.dismiss()">
        Отмена
      </button>
      <button type="submit" class="btn btn-outline-success" (click)="onSubmitUpdateUser(modal)">
        Сохранить
      </button>
    </div>
  </div>
</ng-template>
